
const Main = () => import('@/views/main');
const initiate = () => import('@/views/audit/initiated');
const verify = () => import('@/views/audit/verify');

export default [{
    path: '/audit',
    name: 'audit',
	redirect: {
		name: 'initiate'
	},
    component: Main,
    meta: {
        hide: false,
        name: '审核管理',
        unfold: true,
        iconType: '14'
    },
    children: [
        {
            path: '/initiate',
            name: 'initiate',
            component: initiate,
            meta: {
                name: '我发起的'
            },
        },
        {
            path: '/verify',
            name: 'verify',
            component: verify,
            meta: {
                name: '待我确认'
            },
        },
    ]
}]

